module.exports = __webpack_public_path__ + "static/a-community-of-writers-julia-joppien-578b92e3be0d2d585585a85e91363cee.jpg";